module.exports = __webpack_public_path__ + "img/Phone_06.e28f17ab.jpg";